import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  Box,
} from "@material-ui/core";
import * as Constants from "../../Constants/Styles";
import { NavLink } from "react-router-dom";

const UserItem = (props) => {
  const classes = Constants.useStyles();

  return (
    <Box>
      <Card className={classes.cardRoot} raised>
        <CardMedia
          image={props.user.avatar_url}
          title={props.user.login}
          className={classes.cardRoundedImage}></CardMedia>
        <CardContent>
          <Typography variant="h5" align="center" color="textSecondary">
            {props.user.login}
          </Typography>
        </CardContent>
        <CardActions style={{ justifyContent: "center" }}>
          <Button variant="contained" color="secondary" size="large">
            <NavLink
              to={"/user/" + props.user.login}
              className={classes.navLink}>
              More
            </NavLink>
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default UserItem;
